module.exports = __webpack_public_path__ + "img/proyecto1.bc7e1548.png";